// extracted by mini-css-extract-plugin
module.exports = {"icon":"TokenIcon_icon__grpu0","inherit":"TokenIcon_inherit__24PcR"};